import React from 'react';
import styled from 'styled-components';
import '../Band/Band.css';
import { FILE } from '../../utils/constants/pdf';

const MainWrapper = styled.div`
  height: 92vh;
  width: 100%;

  h3 {
    margin-top: 40px;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  li {

  }
`;

const AreaB = () => {
  return (
    <MainWrapper>
      <div className="component_img" />
      <h3>Area B 5A Marching Contest information</h3>


     <li className="band-link home-info">
      <a href="https://drive.google.com/drive/folders/1PI3deoI4PYpvkTej2tRsuaBkculwJMyf?usp=sharing"
      target="blank"
      >Link to Area B 5A shared folder</a>
        </li>
      <li className="band-link home-info">
      <a href={FILE.areaB2025}
      target="blank"
      >Area B 5A Prelims Draw Order</a>
        </li>

    </MainWrapper>
  );
};

export default AreaB;



// WEBPACK FOOTER //
// ./src/Components/AreaB/index.js